import LuckyDrawPrizeCardComponent from "./luckyDrawPrizeCard.container";

export default LuckyDrawPrizeCardComponent;
